import React from 'react';
import { Box, Typography, Container, Paper, Divider, Link } from '@mui/material';

const Terms = () => {
  const handlePrivacyClick = () => {
    window.open('/privacy', '_blank');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'rgba(228, 228, 228, 0.6)',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Paper elevation={2} sx={{ p: 4, borderRadius: 3 }}>
          <Typography variant="h3" component="h1" sx={{ mb: 3, textAlign: 'center', fontWeight: 600, color: 'primary.main'}}>
            PageSmooth 用户服务协议
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
            生效日期：2025年5月28日 | 最后更新：2025年5月28日
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            尊敬的用户，欢迎您使用PageSmooth签证翻译服务。在使用前请您仔细阅读以下条款及
            <Link
              onClick={handlePrivacyClick}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              《PageSmooth用户隐私政策》
            </Link>
            等平台规则内容，如果您对本协议中的任何条款表示异议，您可以选择不使用PageSmooth；但如果您使用PageSmooth，将视为您已充分理解且同意本协议的所有条款，且具有浏览PageSmooth平台信息、使用翻译服务等PageSmooth平台服务的相应权利能力和行为能力，并可以对自己的行为承担法律责任。
          </Typography>
          
          <Divider sx={{ mb: 4 }} />
          
          <Box sx={{ '& > *': { mb: 4 } }}>
            {/* 第一章 总则 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第一章 总则
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第一条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth是由郑州译悦翻译有限公司向用户提供专业签证文件机器翻译服务的产品，并在www.pagesmooth.com上提供在线服务。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth的所有权、经营权、管理权均属郑州译悦翻译有限公司。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  本协议适用于PageSmooth提供的所有翻译服务，包括但不限于签证证件翻译、文档翻译、图片翻译、认证翻译等服务。
                </Typography>
              </Box>
            </Box>

            {/* 第二章 服务内容 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第二章 服务内容
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  PageSmooth主要提供以下服务：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>多格式文档翻译（PDF、Word、图片等）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>智能文档解析和格式保持；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>专业认证翻译服务（普通翻译认证、澳大利亚NAATI认证等）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>AI智能翻译结合人工审核；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>多语种互译服务；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>企业级批量翻译服务。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第五条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  翻译流程说明：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>文件上传</strong>：用户上传需要翻译的文档；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>文档解析</strong>：系统识别文档内容和格式；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>机器翻译</strong>：使用先进AI大模型进行翻译；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>人工审核</strong>：专业译员进行质量审核（付费服务）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>格式重构</strong>：保持原文档格式生成翻译结果；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>结果交付</strong>：提供多种格式的翻译文件。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第六条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  服务特点：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>支持多语种互译；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>像素级格式保持和排版还原；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>提供普通翻译认证、澳大利亚NAATI等专业认证；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>企业级数据安全保障；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>智能文档类型识别（支持20+种文档类型）。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第三章 点数系统 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第三章 点数系统
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第七条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  点数计费规则：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth采用点数制计费，每页翻译消耗对应的点数，其中图片按1页计算，PDF、Word按实际页数计算；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>对于需要进行普通翻译认证（包含人工审核）或澳大利亚NAATI认证（包含人工审核）等服务的需要支付额外的点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>对于用户需求进行加急服务的，同样需要支付额外的点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>点数一经购买，永不过期；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>点数仅可用于翻译服务，不可转让或兑换现金；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>系统将根据文档页数自动计算所需点数。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第八条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  点数套餐：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>体验套餐</strong>：PageSmooth将不定期推出免费试用点数活动，用户可以根据活动规则参加。</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>购买套餐</strong>：PageSmooth会设定不同的点数包，用户可以根据自己的需求进行购买。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第九条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  点数消费和退还：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译任务创建时立即扣除相应点数，用户可在个人中心查看详细的点数消费记录；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译任务创建后，系统正常翻译，非系统异常等原因点数不可退还；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>任务失败时，系统将自动退还已扣除的点数</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>点数退还将在任务状态确认后24小时内完成</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户可在个人中心查看详细的点数消费记录</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第四章 免责声明 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第四章 免责声明
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  郑州译悦翻译有限公司不对翻译内容的合法性、真实性以及是否侵权承担任何形式的责任。用户委托PageSmooth翻译的内容，不得违反国家法律和损害第三方合法权益。如果出现此种情形，PageSmooth有权拒绝提供翻译服务；如PageSmooth已经翻译完毕的，用户应承担全部责任，并有义务保证PageSmooth不会因此遭受任何损失，否则PageSmooth有权要求用户赔偿因此造成的全部损失。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十一条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth基本原理是结合AI智能翻译和人工专业审核，翻译结果经过多重质量控制流程。PageSmooth对翻译结果的准确性承担相应责任，但不对因用户理解偏差、使用不当、第三方API服务中断等原因造成的损失承担责任。PageSmooth根据用户上传的内容提供翻译服务，不代表PageSmooth赞成上传内容及翻译结果的内容或立场。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十二条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  针对认证翻译服务，如用户对翻译结果有异议，应在收到翻译件后7日内通过平台客服提出，否则即视为用户对于翻译结果满意。用户认可并理解，翻译的结果因语言差异而存在多种表达方式。如翻译的稿件整体意思准确传达，个别词汇翻译存在合理差异的，不应认定为PageSmooth翻译质量存在问题。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十三条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth提供的签证证件翻译服务，主要针对特定的出国留学、出国旅游、移民、企业出海等场景的签证办理过程中所需要的包括个人身份证件、家庭证件、银行流水、成绩单、营业执照等特定类型的证件进行专门的处理和优化，最大限度确保翻译格式、翻译意思与用户原始上传的文件相匹配，但由于AI技术的特性，以及在不同语言语种下，文档显示的差异性，并不能确保100%与原始样式一摸一样，不应认定为PageSmooth翻译质量存在问题。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十四条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  对非PageSmooth支持的文件类型和格式，用户上传后，PageSmooth有权基于系统具备的能力进行翻译，但不对质量作保证。同时也有权进行打回不处理，对于已处理的需要根据点数计费规则进行扣除点数，对于打回不处理的会相应退回已扣除的用户点数。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十五条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  文件处理限制：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>单个文件大小不超过100MB；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>单个文件页数不超过100页；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>单次上传文件数量不超过10个；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不支持加密或密码保护的文件；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不支持损坏或格式异常的文件。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十六条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  您充分知晓并保证您在PageSmooth使用相关功能时上传、发布的内容享有合法权益，若发布的内容发生权利纠纷或侵犯了任何第三方的合法权益，由您承担全部法律责任。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十七条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth尊重并保护所有用户的个人隐私权，但PageSmooth在此提醒用户：您在使用PageSmooth时输入的翻译内容将按照隐私政策进行处理和保护。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十八条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  由于系统发生故障、第三方API服务中断、网络异常等不可控因素导致影响PageSmooth的正常运行，PageSmooth承诺及时处理并进行修复，但用户因此而产生的纠纷和损失，PageSmooth概不负责，亦不承担任何法律责任。此外，PageSmooth保留不经事先通知而为维修、升级或其他目的暂停本服务全部或任何部分的权利。
                </Typography>
              </Box>
            </Box>

            {/* 第五章 服务费用 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第五章 服务费用
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第十九条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  PageSmooth所有服务以付费方式提供。付费服务包括：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>基础翻译服务</strong>：按页计费，每页消耗额定的点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>认证翻译服务</strong>：提供普通翻译认证、澳大利亚NAATI等官方认证，额外收费；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>人工审核服务</strong>：专业译员人工审核，提升翻译质量；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>加急服务</strong>：优先处理，缩短翻译时间；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>企业定制服务</strong>：批量翻译、大客户点数充值优惠等定制化服务。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth可能根据实际需要对收费服务的收费标准、方式进行修改和变更。前述修改、变更或开始收费前，PageSmooth将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十一条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  虚拟商品退款政策：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户购买的点数、会员等虚拟商品，一经购买概不退款；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因PageSmooth系统故障导致的损失，将按实际损失进行补偿；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译任务失败时，系统将自动退还相应点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>恶意刷单、违规使用等行为不予退款；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>对于平台推出的免费试用等活动，如果出现恶意刷单、恶意逃单、违规使用等行为，PageSmooth保留追索平台损失的一切权利。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第六章 权利声明 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第六章 权利声明
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十二条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  当用户发现PageSmooth侵犯其合法权益时，权利人应事先向PageSmooth发出"权利通知"，PageSmooth将根据中国法律法规和政府规范性文件采取措施移除或修改相关翻译结果，并将结果反馈权利人。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十三条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  权利通知应包含以下内容：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>权利人对涉嫌侵权内容拥有著作权、商标权和/或其他依法可以行使权利的权属证明；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>充分、明确地描述被涉嫌侵犯了权利人合法权益的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>提供权利人具体的联络信息，包括真实姓名、身份证明、联系地址、电话号码和电子邮件；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>权利通知的真实性声明；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>权利人签名或盖章。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第七章 服务使用规范 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第七章 服务使用规范
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十四条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  在使用PageSmooth服务过程中，您承诺：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>遵守国家各项法律、法规的规定和要求，遵守诚实信用原则；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不损害社会公共利益或违反公共道德；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不损害他人的合法权益；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不违反本协议的规则和精神；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不上传包含违法、有害、威胁、辱骂、骚扰、侵权、中伤、粗俗、猥亵或其他不当内容的文档。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十五条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  禁止行为包括但不限于：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>上传包含国家机密、商业机密等敏感信息的文档；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>上传包含个人隐私信息且未经授权的文档；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>恶意攻击、干扰或破坏PageSmooth系统；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>使用技术手段批量获取PageSmooth服务或绕过计费系统；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>将PageSmooth服务用于任何违法违规目的；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>侵犯PageSmooth或第三方的知识产权；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>上传病毒、恶意代码或其他可能损害系统的文件；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>尝试逆向工程、反编译或破解PageSmooth系统。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十六条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  文件内容限制：
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  1. 不得上传包含以下内容的文档：
                </Typography>
                <Box component="ul" sx={{ pl: 5 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>反对宪法所确定的基本原则的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>危害国家安全、泄露国家秘密的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>煽动民族仇恨、民族歧视的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>散布谣言、扰乱社会秩序的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>淫秽、色情、暴力、恐怖内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>侵犯他人隐私、名誉权的内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>其他违法违规内容。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十七条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth有权对违反上述规定的用户采取包括但不限于警告、限制使用、暂停服务、终止服务、冻结账户等措施，并有权拒绝处理相关翻译任务。
                </Typography>
              </Box>
            </Box>

            {/* 第八章 信息保护与管理 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第八章 信息保护与管理
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十八条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth非常重视保护用户信息。在您使用PageSmooth服务的过程中，我们会基于您需求的服务，收集和使用您的个人信息。
                  <Link
                    onClick={handlePrivacyClick}
                    sx={{
                      color: 'primary.main',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    《PageSmooth用户隐私政策》
                  </Link>
                  详细说明了我们如何收集、使用、存储和保护您的信息。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第二十九条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  用户注册和账户管理：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>您在使用PageSmooth的部分功能时，需先注册成为用户；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>您应该保证注册的个人资料是真实且准确的；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>您应自行对您的账号密码及相关资料负责；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>您不得以任何形式转让或授权他人使用您的账号；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>如发现账号被盗用，应立即联系客服处理。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  数据安全保障：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>加密存储</strong>：所有上传文件采用AES-256等加密算法存储；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>访问控制</strong>：严格的用户身份验证和权限控制；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>数据隔离</strong>：用户数据完全隔离，互不可见；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>自动删除</strong>：翻译完成后可选择自动删除原文档；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>备份机制</strong>：重要数据多重备份，确保数据安全；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>安全审计</strong>：定期进行安全审计和漏洞检测；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>传输加密</strong>：所有数据传输采用HTTPS加密。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十一条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  文件处理和存储：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>上传的文件将在服务器上临时存储，用于翻译处理；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译完成后，原文件将在7天后自动删除（用户可选择立即删除）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译结果文件将保存7天，供用户下载；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户可随时通过平台删除自己的文件和翻译记录；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>系统日志仅保留必要的操作记录，不包含文件内容。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第九章 服务变更或终止 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第九章 服务变更或终止
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十二条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  PageSmooth有权自行决定以任何理由暂停、中断或终止向用户提供本协议项下的全部或部分服务，暂时冻结或永久冻结用户账号权限。终止情形包括但不限于：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户提供的信息不具有真实性、完整性或有效性；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户违反法律法规或本协议规定；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户恶意使用服务或进行欺诈行为；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户涉嫌再次注册使用本服务；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>本协议变更时，用户明示不愿接受经修改的协议；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户长期未使用服务（超过2年）。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十三条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  服务终止后的处理：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth有权对账号相关内容及信息进行删除或处理；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户未使用的点数将被清零，不予退还；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户在服务终止前的翻译记录将按数据保留政策处理；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户应独立承担因服务终止产生的任何争议和损失。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十四条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  紧急情况处理：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>遇到系统故障、安全威胁等紧急情况时，PageSmooth有权立即暂停服务；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>暂停期间产生的损失，PageSmooth将根据实际情况进行合理补偿；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>服务恢复后，PageSmooth将优先处理暂停期间的任务。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第十章 知识产权 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第十章 知识产权
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十五条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth平台上的所有内容，包括但不限于文字、图像、标识、界面设计、程序代码、算法模型等，均受中华人民共和国著作权法、商标法等法律保护，属于PageSmooth或其授权方所有。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十六条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  用户在使用PageSmooth服务时：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不得复制、修改、传播PageSmooth的任何内容；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不得进行反向工程、反编译等行为；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>不得使用PageSmooth的商标、标识等知识产权；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译结果的知识产权归用户所有；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth保留为改进服务而使用匿名化、去标识化数据的权利；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户授权PageSmooth使用翻译数据进行服务质量分析和改进。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十七条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  第三方知识产权保护：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth尊重第三方知识产权，不会故意侵犯他人权益</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>如发现翻译内容涉及侵权，PageSmooth将配合权利人进行处理</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>用户应确保上传内容不侵犯第三方知识产权</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因用户上传内容导致的侵权纠纷，由用户承担全部责任</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第十一章 责任限制 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第十一章 责任限制
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十八条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  在法律允许的最大范围内，PageSmooth对以下情况不承担责任：
                </Typography>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因不可抗力（自然灾害、政府行为、网络攻击等）导致的服务中断或延迟；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因用户设备故障、网络异常等用户端原因导致的服务异常；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因第三方API服务中断或异常导致的翻译延迟或失败；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因用户违规使用导致的账号封禁或数据丢失；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>超出PageSmooth控制范围的其他情况。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第三十九条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  赔偿责任限制：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>PageSmooth的赔偿责任以用户实际支付的服务费用为限；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>对于间接损失、利润损失等，PageSmooth不承担赔偿责任；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>因系统故障导致的翻译失败，PageSmooth将退还相应点数；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>对于认证翻译服务的质量问题，PageSmooth承担重新翻译的责任。</Typography>
                </Box>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  服务水平承诺：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>系统可用性：99.5%以上（不包括维护时间）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>翻译准确率：95%以上（基于专业评估标准）；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>响应时间：一般翻译任务24小时内完成；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>客服响应：工作时间内24小时内响应。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第十二章 争议解决 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第十二章 争议解决
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十一条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十二条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  如您和PageSmooth就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向PageSmooth所在地人民法院提起诉讼。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十三条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  争议处理流程：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>客服协商</strong>：首先通过在线客服或邮件进行沟通；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>投诉处理</strong>：通过官方投诉渠道提交正式投诉；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>内部调解</strong>：PageSmooth内部调解团队进行处理；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>第三方调解</strong>：必要时可申请第三方调解机构调解；</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>法律途径</strong>：最终通过法律途径解决争议。</Typography>
                </Box>
              </Box>
            </Box>

            {/* 第十三章 其他条款 */}
            <Box>
              <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}>
                第十三章 其他条款
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十四条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  本协议自您同意并开始使用PageSmooth服务时生效。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十五条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  PageSmooth有权根据业务发展需要修改本协议，修订后的协议将在平台上公布，并通过邮件、站内信等方式通知用户。您继续使用服务即视为同意修订后的协议。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十六条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  如本协议中的任何条款无效或不可执行，不影响其他条款的效力。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十七条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  本协议构成双方就相关事项的完整协议，取代之前的所有口头或书面协议。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十八条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  本协议的最终解释权归郑州译悦翻译有限公司所有。
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第四十九条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
                  特殊条款：
                </Typography>
                <Box component="ol" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>测试期间</strong>：服务测试期间的特殊规则以公告为准</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>活动优惠</strong>：促销活动期间的特殊条款以活动页面为准</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>企业用户</strong>：企业用户可能适用额外的企业服务协议</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}><strong>用户知悉并同意</strong>，由于AI技术和机器翻译服务基于人工智能算法自动生成结果，可能存在语义偏差、文化误译及专业术语不准确等情况，对于未选择普通翻译认证或澳大利亚NAATI认证的包含人工审核服务的翻译结果，准确率承诺不直接适用于以下场景：</Typography>
                </Box>
                <Box component="ul" sx={{ pl: 3 }}>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>专业领域文档（签证、法律、医学、工程等）</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>包含俚语、诗歌等非标准化表达的内容</Typography>
                  <Typography component="li" variant="body1" sx={{ mb: 1 }}>低资源语种互译（少于百万级语料库的语种）</Typography>
                </Box>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  5. 用户使用翻译结果时需进行二次校验，特别在涉及法律效力的场景
                </Typography>
              </Box>
              
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>第五十条</Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  AI生成内容标识声明：
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, fontStyle: 'italic', color: 'text.secondary' }}>
                  "本翻译结果由人工智能系统自动生成，可能存在语义偏差。如需法律效力文件，请选择带有[认证翻译]标识的服务，并使用经NAATI认证的版本。"
                </Typography>
              </Box>
            </Box>

            {/* 重要提醒 */}
            <Box sx={{ mt: 6, p: 3, backgroundColor: 'rgba(255, 193, 7, 0.1)', borderRadius: 2, border: '1px solid rgba(255, 193, 7, 0.3)' }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#f57c00' }}>重要提醒</Typography>
              <Box component="ul" sx={{ pl: 3 }}>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>请在使用服务前仔细阅读本协议</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>如有疑问，请及时联系客服咨询</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>建议定期查看协议更新内容</Typography>
                <Typography component="li" variant="body1" sx={{ mb: 1 }}>保留好翻译文件和交易记录</Typography>
              </Box>
            </Box>

            {/* 联系方式 */}
            <Box sx={{ mt: 6, p: 3, backgroundColor: 'rgba(67, 83, 255, 0.05)', borderRadius: 2 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>联系方式</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>客服邮箱：support@pagesmooth.com</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>在线客服：平台内置官方客服微信</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>公司地址：河南省郑州市巩义市紫荆路街道紫荆路29号科创大厦1216室</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>工作时间：周一至周五 9:00-18:00</Typography>
            </Box>

            {/* 版权信息 */}
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography variant="body1" sx={{ mb: 2, fontStyle: 'italic' }}>
                再次感谢您对PageSmooth的信任和使用！
              </Typography>
              <Typography variant="body2" color="text.secondary">
                © 2025 郑州译悦翻译有限公司 版权所有
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms; 